import { VideoPlayer } from "./player";

document.addEventListener("DOMContentLoaded", function () {
    const careersSection = document.querySelector(".careers");
    if (!careersSection) return;

    const playerContainer = careersSection.querySelector(".player");
    const overlayPlay = careersSection.querySelector(".careers__video-play");
    if (!playerContainer) return;

    // Initialize shared VideoPlayer for careers module
    const player = new VideoPlayer(playerContainer, { controls: { position: "left" } });

    const controls = playerContainer.querySelector(".player__controls");
    const videoEl = playerContainer.querySelector(".player__video");

    if (controls) {
        controls.style.opacity = 0;
        controls.style.pointerEvents = "none";
    }

    const showControls = () => {
        if (!controls) return;
        controls.style.opacity = 1;
        controls.style.pointerEvents = "auto";
    };

    const hideControls = () => {
        if (!controls) return;
        controls.style.opacity = 0;
        controls.style.pointerEvents = "none";
    };

    const handleStartPlayback = () => {
        player.play();
        if (overlayPlay) overlayPlay.style.display = "none";
        showControls();
    };

    if (overlayPlay) {
        overlayPlay.addEventListener("click", handleStartPlayback);
    }

    if (videoEl) {
        videoEl.addEventListener("pause", () => {
            if (overlayPlay) overlayPlay.style.display = "flex";
            hideControls();
        });
        videoEl.addEventListener("play", () => {
            if (overlayPlay) overlayPlay.style.display = "none";
            showControls();
        });
    }
});
